// Copyright (c) 2026 Solartek LLC. All rights reserved.

import { registerNamespace } from '@/lib/i18n-namespace';
import en from '@/locales/en/statement.json';
import ar from '@/locales/ar/statement.json';
import leaveEn from '@/locales/en/leave.json';
import leaveAr from '@/locales/ar/leave.json';

/**
 * Workforce controls §5 — "My statement" (portal) and the Statement tab of the employee profile; it reuses the leave labels
 * and the short leave feature's (its categories and statuses: importing that namespace registers it).
 */
export const ST_NS = 'statement';
registerNamespace(ST_NS, en, ar);
registerNamespace('leave', leaveEn, leaveAr);
